import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useCommissions } from '../../_hocs/withCommissions';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../_partials/SelectedItemsPanel';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import Grid from '../../../Grid';
import ShopThumb from '../../../DeviationViews/Thumb/Shop/ShopThumb';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './CommissionSelector.scss';

interface Props {}

const CommissionSelector: React.FC<Props> = () => {
  const isMobile = useContext(MobileContext);
  const {
    isCommissionStreamInitialized,
    commissions,
    isFetchingCommissions,
    hasMoreCommissions,
    fetchMoreCommissions,
  } = useCommissions();

  const fetchMoreIfNeeded = useCallback(() => {
    if (!hasMoreCommissions || isFetchingCommissions) {
      return;
    }
    fetchMoreCommissions();
  }, [hasMoreCommissions, isFetchingCommissions, fetchMoreCommissions]);

  const renderGridElement = ({ index, width, style }) => {
    const commission = commissions[index];

    return (
      <div style={style}>
        <SelectableDeviationWrapper key={commission.deviationId} deviation={commission}>
          <ShopThumb addLink={false} width={width} deviation={commission} />
        </SelectableDeviationWrapper>
      </div>
    );
  };

  const renderContent = () => {
    if (!commissions.length && isCommissionStreamInitialized && !isFetchingCommissions) {
      return null;
    }

    return (
      <>
        {isCommissionStreamInitialized && commissions.length > 0 && (
          <Grid
            className={s['root']}
            breakpoints={[{ maxWidth: 9999, elementWidth: 330, elementHeight: 340 }]}
            cookieType={MeasuredCookieType.GALLECTION_EXPLORER}
            elementCount={commissions.length}
            renderElement={renderGridElement}
            spacing={isMobile ? 10 : 16}
            enableScrollOptim={false}
          />
        )}
        {(!isCommissionStreamInitialized || isFetchingCommissions) && (
          <LoadingIndicator view="daSymbol" coverMode={!fetchMoreCommissions} />
        )}
      </>
    );
  };

  return (
    <PopupInnerLayout
      headerExtrasBottomZone={<SelectedItemsPanel />}
      scrollableContent={renderContent()}
      onScrolledToBottom={fetchMoreIfNeeded}
      onNotScrollable={fetchMoreIfNeeded}
    />
  );
};
CommissionSelector.displayName = 'CommissionSelector';

export default CommissionSelector;
